<template>
    <v-container class="grey lighten-5" fluid>
        <div>
            <!-- Filters -->
            <v-row>
                <!-- From Date -->
                <v-col md="2">
                    <v-menu
                        v-model="fromDateModal"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    ><template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="search.fromDate"
                            label="From Date"
                            append-icon="mdi-calendar"
                            readonly
                            v-on="on"
                            class="mt-0 pt-0"
                        ></v-text-field
                    ></template>
                        <v-date-picker
                            v-model="search.fromDate"
                            @input="fromDateModal = false"
                            @click:date="handleDateFilters"
                        ></v-date-picker>
                    </v-menu>
                </v-col>

                <!-- To Date -->
                <v-col md="2">
                    <v-menu
                        v-model="toDateModal"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    ><template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="search.toDate"
                            label="To Date"
                            append-icon="mdi-calendar"
                            readonly
                            v-on="on"
                            class="mt-0 pt-0"
                        ></v-text-field
                    ></template>
                        <v-date-picker
                            v-model="search.toDate"
                            @input="toDateModal = false"
                            @click:date="handleDateFilters"
                        ></v-date-picker>
                    </v-menu>
                </v-col>

                <!-- Card Issuer -->
                <v-col md="2" >
                    <v-select
                        v-model="search.issuer"
                        :items="issuers"
                        dense
                        label="Card Issuer"
                        append-icon="mdi-magnify"
                        class="mt-0 pt-0"
                        @change="getTransactions(); updateCharts();"
                        clearable
                        @click:clear="search.issuer = null; getTransactions(); updateCharts();"
                    ></v-select>
                </v-col>

                <!-- Merchant IDs -->
                <v-col md="2" >
                    <v-select
                        v-model="search.merchant_id"
                        :items="merchant_ids"
                        dense
                        label="Merchant ID"
                        append-icon="mdi-magnify"
                        class="mt-0 pt-0"
                        @change="getTransactions(); updateCharts();"
                        clearable
                        @click:clear="search.merchant_id = null; getTransactions(); updateCharts();"
                    ></v-select>
                </v-col>

                <!-- Chain IDs -->
                <v-col md="2" >
                    <v-select
                        v-model="search.chain_id"
                        :items="chain_ids"
                        dense
                        label="Chain ID"
                        append-icon="mdi-magnify"
                        class="mt-0 pt-0"
                        @change="getTransactions(); updateCharts();"
                        clearable
                        @click:clear="search.chain_id = null; getTransactions(); updateCharts();"
                    ></v-select>
                </v-col>

                <!-- Merchant Names -->
                <v-col md="2" >
                    <v-select
                        v-model="search.merchant_name"
                        :items="merchant_names"
                        dense
                        label="Merchant Name"
                        append-icon="mdi-magnify"
                        class="mt-0 pt-0"
                        @change="getTransactions(); updateCharts();"
                        clearable
                        @click:clear="search.merchant_name = null; getTransactions(); updateCharts();"
                    ></v-select>
                </v-col>

                <!-- Locations -->
                <v-col md="2" >
                    <v-select
                        v-model="search.location"
                        :items="locations"
                        dense
                        label="Location"
                        append-icon="mdi-magnify"
                        class="mt-0 pt-0"
                        @change="getTransactions(); updateCharts();"
                        clearable
                        @click:clear="search.location = null; getTransactions(); updateCharts();"
                    ></v-select>
                </v-col>

                <!-- Payment Brands -->
                <v-col md="2" >
                    <v-select
                        v-model="search.payment_brand"
                        :items="payment_brands"
                        dense
                        label="Payment Brand"
                        append-icon="mdi-magnify"
                        class="mt-0 pt-0"
                        @change="getTransactions(); updateCharts();"
                        clearable
                        @click:clear="search.payment_brand = null; getTransactions(); updateCharts();"
                    ></v-select>
                </v-col>

                <!-- Card Types -->
                <v-col md="2" >
                    <v-select
                        v-model="search.card_type"
                        :items="card_types"
                        dense
                        label="Card Type"
                        append-icon="mdi-magnify"
                        class="mt-0 pt-0"
                        @change="getTransactions(); updateCharts();"
                        clearable
                        @click:clear="search.card_type = null; getTransactions(); updateCharts();"
                    ></v-select>
                </v-col>
            </v-row>

            <!-- Transactions Table -->
            <v-data-table
                :headers="tableHeaders"
                :items="tableData"
                :items-per-page="10"
                :loading="loading"
                class="elevation-1"
            >
            </v-data-table>
        </div>

        <div class="mt-3">
            <v-row>
                <v-col md="6">
                    <chart1
                        v-if="chartData1"
                        ref="chart1"
                        :chartData="chartData1"
                    ></chart1>
                </v-col>
                <v-col md="6">
                    <chart2 
                        v-if="chartData2"
                        ref="chart2"
                        :chartData="chartData2"
                    ></chart2>
                </v-col>
                <v-col md="6">
                    <chart3 
                        v-if="chartData3"
                        ref="chart3"
                        :chartData="chartData3"
                    ></chart3>
                </v-col>
                <v-col md="6">
                    <chart4
                        v-if="chartData4"
                        ref="chart4"
                        :chartData="chartData4"
                    ></chart4>
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import Chart1 from '@/components/niPos/charts/NiPosChart1.vue';
import Chart2 from '@/components/niPos/charts/NiPosChart2.vue';
import Chart3 from '@/components/niPos/charts/NiPosChart3.vue';
import Chart4 from '@/components/niPos/charts/NiPosChart4.vue';

export default {
    components: {
        'chart1': Chart1,
        'chart2': Chart2,
        'chart3': Chart3,
        'chart4': Chart4
    },
    data() {
        return {
            initialLoad: false,
            tableHeaders: [{ text: 'Date', value: 'processingTime', sortable: true, align: 'left', width: 130 },
                           { text: 'Merchant ID', value: 'merchant_id', sortable: false },
                           { text: 'Chain ID', value: 'chain_id', sortable: false },
                           { text: 'Merchant Name', value: 'merchant_name', sortable: false },
                           { text: 'Location', value: 'location', sortable: false },
                           { text: 'Terminal ID', value: 'terminal_id', sortable: false, align: 'center' },
                           { text: 'Amount', value: 'amount', sortable: false, align: 'center' },
                           { text: 'Currency', value: 'currency', sortable: false, align: 'center' },
                           { text: 'Payment Type', value: 'paymentType', sortable: false, align: 'center' },
                           { text: 'Payment Brand', value: 'paymentBrand', sortable: false, align: 'center' },
                           { text: 'BIN', value: 'bin', sortable: false, align: 'center' },
                           { text: 'Last4Digits', value: 'last4Digits', sortable: false, align: 'center' },
                           { text: 'Commission', value: 'commission', sortable: true, align: 'center' },
                           { text: 'Commission Rate', value: 'commission_rate', sortable: true, align: 'center' },
                           { text: 'VAT Amount', value: 'vat_amount', sortable: false, align: 'center' },
                           { text: 'NET Amount', value: 'net_amount', sortable: false, align: 'center' },
                           { text: 'Card Issuer', value: 'card_issuer', sortable: false, align: 'center' },
                           { text: 'Card Type', value: 'card_type', sortable: false, align: 'center' },
                           { text: 'Card Level', value: 'card_level', sortable: false, align: 'center' },
                           { text: 'BIN Type', value: 'bin_type', sortable: false, align: 'center' },
                           { text: 'Card Country', value: 'card_country', sortable: false, align: 'center' }],
            tableData: [],
            search: { fromDate: moment().startOf('month').format('YYYY-MM-DD'),
                      toDate: new Date().toISOString().substr(0, 10)
            },
            fromDateModal: null,
            toDateModal: null,
            issuers: [],
            merchant_ids: [],
            chain_ids: [],
            merchant_names: [],
            location: [],
            payment_brands: [],
            card_types: [],
            chartData1: null,
            chartData2: null,
            chartData3: null,
            chartData4: null,
            loading: false
        }
    },
    beforeMount() {
        this.getTransactions();
        this.updateCharts();
    },
    computed: {
        
    },
    methods: {
        getTransactions() {
            this.loading = true;

            axios({
            method: 'post',
            url: 'get-transactions-live-gourmet',
            data: { search: this.search },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.tableData = response.data;

                if(!this.initialLoad) {
                    this.issuers = this.tableData.filter(e => e.card_issuer != null).map(e => e.card_issuer);
                    this.merchant_ids = this.tableData.map(e => e.merchant_id);
                    this.chain_ids = this.tableData.map(e => e.chain_id);
                    this.merchant_names = this.tableData.map(e => e.merchant_name);
                    this.locations = this.tableData.map(e => e.location);
                    this.payment_brands = this.tableData.map(e => e.paymentBrand);
                    this.card_types = this.tableData.map(e => e.card_type);

                    this.issuers.sort();
                    this.merchant_ids.sort();
                    this.chain_ids.sort();
                    this.merchant_names.sort();
                    this.locations.sort();
                    this.payment_brands.sort();
                    this.card_types.sort();
                }
                this.initialLoad = true;
                this.loading = false;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        getChart1() {
            axios({
            method: 'post',
            url: 'get-chart1-live-gourmet',
            data: { search: this.search },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.chartData1 = response.data;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        getChart2() {
            axios({
            method: 'post',
            url: 'get-chart2-live-gourmet',
            data: { search: this.search },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.chartData2 = response.data;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        getChart3() {
            axios({
            method: 'post',
            url: 'get-chart3-live-gourmet',
            data: { search: this.search },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.chartData3 = response.data;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        getChart4() {
            axios({
            method: 'post',
            url: 'get-chart4-live-gourmet',
            data: { search: this.search },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.chartData4 = response.data;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        bst(time) {
            if(moment(time).isDST()) {
                return moment(time).add(1, 'hour').format('YYYY-MM-DD HH:mm:ss');
            }
            else {
                 return time;
            }
        },
        handleDateFilters() {
            if(this.search.toDate < this.search.fromDate) {
                this.search.fromDate = this.search.toDate;
            }
            this.getTransactions();
            this.updateCharts();
        },
        updateCharts() {
            this.getChart1();
            this.getChart2();
            this.getChart3();
            this.getChart4();
        }
    }
}
</script>

<style>
    .v-data-table td {
        font-size: 0.6rem !important;
    }

    .stats {
        display: inline-flex;
        vertical-align: middle;
        align-items: center;
    }
</style>